var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "&ns_svg;",
    xmlnsXlink: "&ns_xlink;",
    width: 40,
    height: 40,
    viewBox: "107.709 107.708 40 40",
    style: {
      overflow: "visible",
      enableBackground: "new 107.709 107.708 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 120.422,
    y: 118.45,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.148,
    height: 14.631
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C4C4C"
    },
    d: "M144.59,117.697c-0.402-1.505-1.588-2.694-3.096-3.096c-2.729-0.729-13.675-0.729-13.675-0.729 s-10.945,0-13.675,0.729c-1.505,0.402-2.694,1.591-3.096,3.096c-0.73,2.73-0.73,8.425-0.73,8.425s0,5.696,0.73,8.423 c0.402,1.503,1.591,2.693,3.096,3.098c2.73,0.732,13.675,0.732,13.675,0.732s10.946,0,13.675-0.729 c1.508-0.404,2.693-1.592,3.096-3.098c0.731-2.73,0.731-8.427,0.731-8.427S145.321,120.428,144.59,117.697z M124.318,131.37v-10.5 l9.095,5.252L124.318,131.37z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.b3ba897de69d2714886d6858380a22d3.svg";
export { ForwardRef as ReactComponent };